import styled, { createGlobalStyle } from 'styled-components';
import { RGBA_COLORS } from './utils/colors';
import { HEADER_HEIGHT } from './utils/consts';

export const GlobalStyle = createGlobalStyle`
html {
  font-family: 'Roboto', sans-serif;
  
}

* {
  font-family: 'Roboto', sans-serif;
  box-sizing: border-box;
}

body {
  margin: 0;
  color: ${RGBA_COLORS.getDefault()};
  min-width: 993px;
}

button {
  cursor: pointer;
  background: none;
  border: 0;
  outline: 0;
  padding: 0;
  color: ${RGBA_COLORS.getDefault()};
  transition: 0.2s;
  &:hover {
    color: ${RGBA_COLORS.getAccent()};
  }
}

main {
  background: rgb(241, 243, 246);
  height: calc(100vh - ${HEADER_HEIGHT});
  display: flex;
  /* padding: 20px; */
  position: relative;
}

a {
  color: rgb(89, 89, 89);
  text-decoration: none;
}
textarea,
input {
  transition: 0.2s;
  color: ${RGBA_COLORS.getDefault()}
}

.animate__zoomIn {
    animation-duration: 0.2s !important;
  }
`;

export const CardS = styled.div`
  background: white;
  padding: 10px;
  border: 1px solid rgb(235, 235, 235);
  display: flex;
  flex-direction: column;
`;
